/**
 * Hinterland: keep the page in view when the window crosses Horizon's 990px layout switch.
 * Below 990px the document scrolls; from 990px up Horizon locks the document (overflow: hidden)
 * and scrolls `.page-wrapper` instead (assets/base.css). A locked document keeps its old scroll
 * offset, so widening a window that was scrolled down left the page shifted up off screen (blank
 * space until a reload); narrowing reset the page to the top. On each switch, hand the last scroll
 * position to the element that now scrolls.
 */

const desktop = window.matchMedia('(min-width: 990px)');
const wrapper = document.querySelector('.page-wrapper');
const page = document.scrollingElement;

// The browser resets .page-wrapper's scroll as soon as it stops scrolling (narrowing), before any
// event can read it, so remember the last position of whichever element was scrolling.
let lastOffset = 0;
let wasDesktop = desktop.matches;

function remember() {
  if (!(wrapper instanceof HTMLElement) || !page) return;
  // Mid-switch (the layout changed but handOff hasn't run yet): keep the old position.
  if (desktop.matches !== wasDesktop) return;
  lastOffset = desktop.matches ? wrapper.scrollTop : page.scrollTop;
}

function handOff() {
  if (!(wrapper instanceof HTMLElement) || !page) return;
  const isDesktop = desktop.matches;

  if (isDesktop && page.scrollTop > 0) {
    // Widened: the locked document still holds the offset.
    const offset = page.scrollTop;
    page.scrollTo({ top: 0, behavior: 'instant' });
    wrapper.scrollTo({ top: offset, behavior: 'instant' });
  } else if (!isDesktop && wasDesktop && page.scrollTop === 0 && lastOffset > 0) {
    // Narrowed: .page-wrapper lost its offset; move the remembered one to the document.
    wrapper.scrollTo({ top: 0, behavior: 'instant' });
    page.scrollTo({ top: lastOffset, behavior: 'instant' });
  }

  wasDesktop = isDesktop;
  remember();
}

if (wrapper instanceof HTMLElement && page) {
  wrapper.addEventListener('scroll', remember, { passive: true });
  window.addEventListener('scroll', remember, { passive: true });
  // The layout switch event, plus resize as a backup (both are no-ops when nothing needs moving).
  desktop.addEventListener('change', handOff);
  window.addEventListener('resize', handOff, { passive: true });
}
